<div
  class="login-container"
  [ngClass]="isDarkMode() ? 'bg-radial-[at_25%_25%] from-teal-950 to-zinc-900 to-75%' : 'bg-white'">
  <div class="login-background">
    <div class="login-card-wrapper">
      <p-card class="login-card shadow-lg bg-white">
        <ng-template pTemplate="header">
          <div class="login-header h-40"></div>
        </ng-template>

        @if (isMaintenance) {
          <div class="login-maintenance-banner px-8 pt-8">
            <p-message severity="warn">
              El sistema se encuentra en mantenimiento. El servicio estará disponible a las
              {{ maintenanceTime }}.
            </p-message>
          </div>
        }

        <form
          [formGroup]="loginForm"
          (ngSubmit)="onSubmit()"
          class="login-form"
          [ngClass]="isDarkMode() ? '' : 'bg-white'">
          <div class="form-field">
            <label for="email" class="form-label">Correo Electrónico</label>
            <span class="p-input-icon-left">
              <i class="pi pi-envelope"></i>
              <input
                id="email"
                type="email"
                data-testid="email-input"
                pInputText
                formControlName="correo_electronico"
                placeholder="Ingrese su correo electrónico"
                [disabled]="isMaintenance"
                [class.ng-invalid]="isFieldInvalid('correo_electronico')"
                [class.ng-dirty]="isFieldInvalid('correo_electronico')"
                class="w-full" />
            </span>
            @if (isFieldInvalid('correo_electronico')) {
              <small class="p-error">
                {{ getErrorMessage('correo_electronico') }}
              </small>
            }
          </div>

          <div class="form-field">
            <label for="password" class="form-label">Contraseña</label>
            <p-password
              id="password"
              data-testid="password-input"
              formControlName="password"
              placeholder="Ingrese su contraseña"
              [feedback]="false"
              [toggleMask]="true"
              [disabled]="isMaintenance"
              [class.ng-invalid]="isFieldInvalid('password')"
              [class.ng-dirty]="isFieldInvalid('password')"
              class="w-full"></p-password>
            @if (isFieldInvalid('password')) {
              <p-message severity="error" size="small" variant="simple">
                {{ getErrorMessage('password') }}
              </p-message>
            }
          </div>

          <div class="form-actions">
            <p-button
              [outlined]="loginForm.invalid || isLoading() || isMaintenance"
              [severity]="
                loginForm.invalid || isLoading() || isMaintenance ? 'secondary' : 'primary'
              "
              type="submit"
              label="Iniciar Sesión"
              data-testid="login-button"
              fluid
              [icon]="getSubmitBtnIcon()"
              [loading]="isLoading()"
              [disabled]="loginForm.invalid || isLoading() || isMaintenance" />
          </div>
        </form>

        <div class="login-footer">
          <img src="/assets/title_bg.png" alt="Logo" class="w-full bg-no-repeat bg-center bg-cover" />
          <img src="/assets/footer_bg.png" alt="Logo" class="h-10 bg-no-repeat bg-center m-auto" />

          @if (versionInfo(); as info) {
            <div class="mt-3 text-center text-gray-500">
              <p class="m-0 text-sm font-medium">Versión {{ info.version }}</p>
              <p class="m-0 text-xs text-gray-400">
                Actualizado en {{ info.updatedAt }}
                @if (info.daysAgo !== null) {
                  · Hace {{ info.daysAgo }} {{ info.daysAgo === 1 ? 'día' : 'días' }}
                }
              </p>
            </div>
          }
        </div>
      </p-card>
    </div>
  </div>
</div>

<p-toast></p-toast>
